import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminLatestTemplateService {
  serviceBaseUrl: string = "";
  isModel: boolean;
  constructor(private http: HttpClient) {
    this.serviceBaseUrl = environment.serviceBaseUrl;
    this.isModel = true;
  }

  getLatestTemplate(): Promise<any> {
    return this.http.get(this.serviceBaseUrl + "Kesavi/GetLatestTemplate").toPromise();
  }

  addLatestTemplate(obj): Promise<any> {
    return this.http.post(this.serviceBaseUrl + 'Kesavi/AddLatestTemplate', obj).toPromise();
  }

  editLatestTemplate(obj): Promise<any> {
    return this.http.post(this.serviceBaseUrl + 'Kesavi/EditLatestTemplate', obj).toPromise();
  }

}
